// 校园反转社 · 内容数据（纯展示用示例数据）

export interface Category {
  key: string;
  name: string;
  desc: string;
  count: number;
  icon: string;
  tone: string;
  img: string;
}

export interface Post {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  time: string;
  categoryKey: string;
  tags: string[];
  heat: number;
  feature?: boolean;
  img?: string;
}

export interface TimelineStage {
  day: string;
  title: string;
  detail: string;
  state: string; // rumor | heat | verify | reverse | settle
}

export interface Faq {
  q: string;
  a: string;
}

export interface Principle {
  icon: string;
  title: string;
  text: string;
}

export const categories: Category[] = [
  {
    key: 'xin',
    name: '新瓜速递',
    desc: '第一时间的瓜，趁热抢先看',
    count: 2,
    icon: 'ri-flashlight-fill',
    tone: 'text-amber-600 bg-amber-50 border-amber-200',
    img: 'https://readdy.ai/api/search-image?query=abstract%20editorial%20burst%20of%20warm%20amber%20light%20rays%20with%20paper%20texture%20in%20cream%20tones%2C%20vibrant%20energy%2C%20dynamic%20composition%2C%20modern%20gossip%20magazine%20style%20illustration%2C%20no%20text&width=600&height=420&seq=cat-xin-1&orientation=landscape',
  },
  {
    key: 'fanzhuan',
    name: '反转打脸',
    desc: '剧情峰回路转，结局意想不到',
    count: 2,
    icon: 'ri-loop-left-line',
    tone: 'text-red-600 bg-red-50 border-red-200',
    img: 'https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20a%20reversal%20arrow%20curve%20in%20chili%20red%20and%20burnt%20orange%20on%20warm%20cream%20paper%2C%20halftone%20dots%2C%20dynamic%20playful%20magazine%20energy%2C%20no%20text&width=600&height=420&seq=cat-fanzhuan-1&orientation=landscape',
  },
  {
    key: 'piyao',
    name: '辟谣现场',
    desc: '谣言止于真相，逐条求证厘清',
    count: 2,
    icon: 'ri-verified-badge-fill',
    tone: 'text-teal-700 bg-teal-50 border-teal-200',
    img: 'https://readdy.ai/api/search-image?query=calm%20abstract%20editorial%20illustration%20with%20checkmark%20shield%20motif%20in%20teal%20and%20sage%20green%20on%20soft%20cream%20paper%2C%20clean%20minimal%20gossip%20magazine%20style%2C%20no%20text&width=600&height=420&seq=cat-piyao-1&orientation=landscape',
  },
  {
    key: 'houxu',
    name: '后续进展',
    desc: '事件不烂尾，全程持续追更',
    count: 2,
    icon: 'ri-refresh-line',
    tone: 'text-orange-600 bg-orange-50 border-orange-200',
    img: 'https://readdy.ai/api/search-image?query=flowing%20abstract%20editorial%20timeline%20ribbon%20in%20soft%20orange%20and%20apricot%20tones%20on%20warm%20cream%20paper%2C%20modern%20minimal%20gossip%20magazine%20illustration%2C%20no%20text&width=600&height=420&seq=cat-houxu-1&orientation=landscape',
  },
  {
    key: 'fupan',
    name: '真相复盘',
    desc: '把来龙去脉一次讲清楚',
    count: 2,
    icon: 'ri-git-merge-line',
    tone: 'text-stone-700 bg-stone-100 border-stone-300',
    img: 'https://readdy.ai/api/search-image?query=analytical%20abstract%20editorial%20illustration%20of%20connected%20nodes%20and%20dotted%20paths%20in%20warm%20gray%20and%20cream%20tones%2C%20journalistic%20clean%20style%2C%20no%20text&width=600&height=420&seq=cat-fupan-1&orientation=landscape',
  },
  {
    key: 'wanjie',
    name: '完结篇',
    desc: '尘埃落定，值得收藏回看',
    count: 2,
    icon: 'ri-flag-fill',
    tone: 'text-emerald-700 bg-emerald-50 border-emerald-200',
    img: 'https://readdy.ai/api/search-image?query=serene%20abstract%20editorial%20illustration%20with%20closing%20ribbon%20and%20seal%20motif%20in%20deep%20emerald%20green%20on%20soft%20cream%20paper%2C%20calm%20settled%20gossip%20magazine%20energy%2C%20no%20text&width=600&height=420&seq=cat-wanjie-1&orientation=landscape',
  },
];

export const posts: Post[] = [
  {
    id: 'fanzhuan-jxj-01',
    title: '“奖学金内定名单”风波反转：录取公示两小时后，当事人清白被还原',
    excerpt:
      '一张流传的“内部名单”截图引发轩然大波，质疑声铺天盖地。谁也没想到，公示名单公开两小时后，教务系统与原始评审记录同时放出，剧情迎来戏剧性大反转。',
    date: '09-08',
    time: '12:40',
    categoryKey: 'fanzhuan',
    tags: ['奖学金', '名单反转', '评审记录'],
    heat: 100,
    feature: true,
    img: 'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%20of%20a%20campus%20noticeboard%20with%20sealed%20documents%20and%20a%20magnifying%20glass%20in%20chili%20red%20and%20cream%20tones%2C%20warm%20dramatic%20lighting%2C%20news%20story%20composition%2C%20no%20readable%20text&width=900&height=560&seq=post-feature-1&orientation=landscape',
  },
  {
    id: 'piyao-shetuan-01',
    title: '网传“社团换届花钱买票”，学生会连夜核查并发布澄清',
    excerpt:
      '聊天记录里一句模棱两可的话被反复截图转发，越传越离谱。学生会连夜调取签到与投票后台，用一份逐条对照的澄清说明堵住了所有猜测。',
    date: '09-08',
    time: '09:15',
    categoryKey: 'piyao',
    tags: ['社团换届', '澄清', '投票记录'],
    heat: 85,
  },
  {
    id: 'houxu-chaqin-01',
    title: '查寝偷拍视频发酵第5天：校方回应与当事人声明全整理',
    excerpt:
      '一段未经授权的查寝拍摄在多个群里疯传，事情发酵到第5天仍未降温。我们把校方回应、宿管说明与当事人声明按时间线完整整理出来。',
    date: '09-07',
    time: '21:30',
    categoryKey: 'houxu',
    tags: ['查寝', '偷拍', '隐私'],
    heat: 89,
  },
  {
    id: 'xin-biaobaiqiang-01',
    title: '校园表白墙惊现代课交易“截图”，网友吵翻后剧情连夜升级',
    excerpt:
      '一张疑似“代课交易”的截图刚被发上墙，评论区就分成两派吵了起来。几个小时后，聊天双方先后发声，事件突然从交易纠纷转向更大范围的对峙。',
    date: '09-07',
    time: '18:02',
    categoryKey: 'xin',
    tags: ['代课', '表白墙', '对峙'],
    heat: 96,
    img: 'https://readdy.ai/api/search-image?query=vibrant%20abstract%20editorial%20illustration%20of%20social%20media%20chat%20bubbles%20colliding%20in%20amber%20and%20chili%20red%20on%20cream%20paper%2C%20playful%20gossip%20magazine%20energy%2C%20no%20readable%20text&width=720&height=460&seq=post-xin-1&orientation=landscape',
  },
  {
    id: 'fupan-shiwu-01',
    title: '“食堂吃出异物”事件全流程复盘：从截图疯传到证实为旧图',
    excerpt:
      '一张模糊照片让食堂被骂了整整一天，最终却被证明是三个月前的旧图。我们把整起乌龙从发酵到澄清的每个节点都拆给你看。',
    date: '09-06',
    time: '14:20',
    categoryKey: 'fupan',
    tags: ['食堂', '旧图', '乌龙'],
    heat: 82,
  },
  {
    id: 'fanzhuan-baoyan-01',
    title: '网传“保研加分造假”？监控与成绩单还原后，方向截然相反',
    excerpt:
      '一份被涂改过的加分表截图让质疑迅速蔓延。可当原始成绩单与教室监控被逐一核对，事件走向完全逆转，真相让当初跟风的人直呼“打脸”。',
    date: '09-06',
    time: '10:05',
    categoryKey: 'fanzhuan',
    tags: ['保研', '加分', '监控还原'],
    heat: 92,
  },
  {
    id: 'piyao-sushe-01',
    title: '“宿舍扣押金”谣言求证：宿管回应与合同条款一次讲清',
    excerpt:
      '“退宿必被扣押金”的传言在新生群里年年发酵。我们翻出公示的入住协议，再请宿管逐条回应，告诉你押金到底什么时候该扣、什么时候不该扣。',
    date: '09-05',
    time: '16:40',
    categoryKey: 'piyao',
    tags: ['宿舍', '押金', '合同'],
    heat: 71,
  },
  {
    id: 'wanjie-xuanke-01',
    title: '“选课系统崩溃”乌龙事件收官：完整时间线一次看全',
    excerpt:
      '一场被传成“系统被黑客攻击”的选课事故，最终被证实只是并发量过大。从挤崩到修复，再到官方说明，这起完结篇给你完整回放。',
    date: '09-05',
    time: '11:30',
    categoryKey: 'wanjie',
    tags: ['选课', '系统', '完结'],
    heat: 74,
  },
  {
    id: 'fupan-banjiquan-01',
    title: '“班级群退群风波”复盘：一小时四连反转的完整记录',
    excerpt:
      '一次普通的班级群争吵，竟在一个小时里连续反转四次。我们把群内截图、私聊记录和后续和解过程拼成一张完整的时间图谱。',
    date: '09-04',
    time: '20:12',
    categoryKey: 'fupan',
    tags: ['班级群', '退群', '反转'],
    heat: 79,
  },
  {
    id: 'houxu-biaobai-01',
    title: '校园网“表白翻车”事件追踪：二次回应与前因后果',
    excerpt:
      '当众表白被拒本已够尴尬，谁料事后双方各执一词，事情二次发酵。我们跟踪到当事人的最新回应，把前因后果补完整。',
    date: '09-03',
    time: '22:05',
    categoryKey: 'houxu',
    tags: ['表白', '翻车', '二次回应'],
    heat: 68,
  },
  {
    id: 'wanjie-shetuanjingfei-01',
    title: '“社团经费去向”质疑定论：财务公开会要点与官方声明',
    excerpt:
      '围绕一笔社团经费的去向，讨论持续了近两周。随着一场公开的财务说明会举行，各项支出被逐条公示，这场争议终于有了定论。',
    date: '09-02',
    time: '15:48',
    categoryKey: 'wanjie',
    tags: ['社团经费', '公开会', '定论'],
    heat: 66,
  },
  {
    id: 'xin-ershou-01',
    title: '二手书群“溢价转卖”之争再起波澜，卖家放出完整聊天记录',
    excerpt:
      '一场关于二手教材溢价的争执原本接近平息，卖家却突然放出完整聊天记录，点名批评者删改原话。剧情再度升温，新瓜不断。',
    date: '09-01',
    time: '19:25',
    categoryKey: 'xin',
    tags: ['二手书', '溢价', '完整记录'],
    heat: 78,
  },
];

export const timelineStages: TimelineStage[] = [
  {
    day: 'Day 1 · 09-04',
    title: '“内部名单”截图开始流传',
    detail: '一张标注着“拟推荐名单”的模糊截图在班群、学院群反复转发，迅速扩散到多个平台，质疑“内定”的声音开始聚集。',
    state: 'rumor',
  },
  {
    day: 'Day 2 · 09-05',
    title: '事件登上热搜，热度急剧上升',
    detail: '截图被配上各种标题二次创作，加上“知情人士”添油加醋，事件热度达到峰值，当事人被卷进舆论漩涡。',
    state: 'heat',
  },
  {
    day: 'Day 3 · 09-06',
    title: '校方介入，辟谣声明先行',
    detail: '相关学院发布初步说明，指出流传名单并非官方文件，同时承诺公开评审与公示流程，请同学们理性看待。',
    state: 'verify',
  },
  {
    day: 'Day 3 晚间 · 09-06',
    title: '公示名单正式放出，剧情反转',
    detail: '教务系统开放正式公示名单，与截图内容明显不符；原始评审记录同步可查，此前的核心质疑被逐一推翻。',
    state: 'reverse',
  },
  {
    day: 'Day 4 · 09-07',
    title: '真相复盘，尘埃落定',
    detail: '反转社结合官方数据与当事双方说明完成复盘：所谓“内定”源于对未定稿文件的误读与断章取义，乌龙就此告一段落。',
    state: 'settle',
  },
];

export const faqs: Faq[] = [
  {
    q: '为什么很多“反转”总是在深夜发生？',
    a: '并不是反转偏爱深夜，而是关键信息（公示名单、系统记录、官方说明）往往在非工作时间完成核对后才集中放出。谣言传播是即时的，而求证需要等待原始数据就位，于是许多澄清都集中在晚间陆续公布，这才给人“深夜反转”的错觉。',
  },
  {
    q: '网上疯传的截图到底能不能信？怎么快速判断真假？',
    a: '单张截图只能说明“有人这么说过”，无法证明“这件事是真的”。建议先问三个问题：截图里的文件/账号是不是官方来源、有没有上下文被裁剪、当事人或官方有没有回应。缺少这三项支撑的“实锤”，都该保持怀疑再观望。',
  },
  {
    q: '“吃瓜吃全套”到底要追什么才算吃明白？',
    a: '一个完整瓜通常包含四个部分：最初的爆料、传播中的变体、当事人或官方回应、最终的复盘结论。只看开头很容易被带节奏，只有把辟谣、反转与结局都补齐，才算真正把来龙去脉看完整。',
  },
  {
    q: '为什么有些看起来“石锤”的黑料最后却被证伪？',
    a: '因为“石锤感”往往来自断章取义、旧图旧闻、被裁剪的聊天记录或张冠李戴。造谣成本低、辟谣成本高，反转正是信息被还原的过程——这也是我们坚持逐条对照原始出处的原因。',
  },
  {
    q: '反转社的内容是怎么保证客观的？',
    a: '我们只整理公开可查的信息源，包括官方通知、公开公示、当事人公开声明等，并把不同版本的说法并列呈现，标注哪些已证实、哪些仍在求证，不做标题党，也不替任何一方站台。',
  },
  {
    q: '如果身边出现伤害性谣言，可以怎么处理？',
    a: '建议第一时间保存原始截图与链接作为证据，不要二次转发扩散；可向对应平台举报，涉及人身攻击或名誉损害的可寻求学校官方或相关渠道帮助。谣言止于求证，而不是止于争论。',
  },
];

export const principles: Principle[] = [
  {
    icon: 'ri-eye-line',
    title: '只拼公开信息',
    text: '每条内容都以官方通知、公开记录与当事人公开声明为依据，不引用来源不明的“内幕”。',
  },
  {
    icon: 'ri-chat-quote-line',
    title: '并列各方说法',
    text: '把不同版本并排呈现，清楚标注“已证实”与“求证中”，不替任何一方提前下结论。',
  },
  {
    icon: 'ri-time-line',
    title: '持续跟踪不烂尾',
    text: '一个瓜追到结局才算完，反转、辟谣、后续、复盘我们一路跟到底，不中途弃坑。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '对伤害性谣言零转发',
    text: '涉及真实个人隐私与名誉的内容一律不扩散，优先提示维权与举报的正确姿势。',
  },
];

export const hotList: Post[] = [...posts]
  .sort((a, b) => b.heat - a.heat)
  .slice(0, 5);